export const siteInfo = {
  name: '深夜爆料',
  slogan: '第一手独家 · 新瓜速递',
  description:
    '深夜爆料新料首发专区，聚焦第一手独家内容，新瓜速递不间断更新，帮你在第一时间抓住最热的那条料。',
  since: '2021',
  email: 'baoliao@shenyebaoliao.com',
  submitEmail: 'tougao@shenyebaoliao.com',
  contactHours: '每日 21:00 — 次日 04:00',
  nav: [
    { label: '首页', path: '/' },
    { label: '娱乐瓜田', path: '/category/yule' },
    { label: '商界秘闻', path: '/category/shangjie' },
    { label: '科技内幕', path: '/category/keji' },
    { label: '圈内实录', path: '/category/quannei' },
    { label: '常见问题', path: '/faq' },
    { label: '关于我们', path: '/about' },
  ],
  stats: [
    { label: '累计首发爆料', value: '3,860+', unit: '条' },
    { label: '深夜在线读者', value: '42.6万', unit: '人/月' },
    { label: '平均首发速度', value: '27', unit: '分钟' },
    { label: '内容复核率', value: '100', unit: '%' },
  ],
  principles: [
    {
      icon: 'ri-fingerprint-line',
      title: '首发优先',
      desc: '与多家线索源保持长期联络，力争在热点发酵前完成第一条成稿，让「抢先看」不是一句口号。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '双重交叉核实',
      desc: '任何一条爆料在发布前，至少经过两位编辑的独立信源交叉比对，未通过核实的线索只会留在待发池。',
    },
    {
      icon: 'ri-eye-off-line',
      title: '保护线索人',
      desc: '投稿默认匿名处理，联系方式与身份信息不入库、不外显，后台仅保留加密后的线索编号。',
    },
    {
      icon: 'ri-error-warning-line',
      title: '错了就改',
      desc: '若后续信息与首发内容冲突，我们会在原文顶部挂出更正说明，而不是悄悄删掉旧稿。',
    },
  ],
  testimonials: [
    {
      name: '凌晨三点还在刷',
      role: '夜班读者 · 关注娱乐瓜田',
      content: '每天下班第一件事就是打开深夜爆料看爆料流，更新时间基本踩在我下班点上，比刷社交平台快多了。',
      initial: '凌',
    },
    {
      name: '老周不熬夜',
      role: '资深吃瓜群众 · 关注商界秘闻',
      content: '喜欢它把一件事的来龙去脉讲清楚，不是扔一句标题就跑，榜单功能也很好用，五分钟抓住今天的重点。',
      initial: '周',
    },
    {
      name: '小满',
      role: '内容从业者 · 关注圈内实录',
      content: '圈内实录这个栏目真的难得，写的是行业里的日常，读完不会有被糊弄的感觉，更新频率也很稳。',
      initial: '满',
    },
  ],
  milestones: [
    { year: '2021', text: '深夜爆料正式上线，首月以「深夜电台」栏目切入夜班人群。' },
    { year: '2022', text: '新增娱乐瓜田与商界秘闻两个栏目，爆料流模式跑通。' },
    { year: '2023', text: '上线热瓜榜与首发提醒，单日最高更新 26 条。' },
    { year: '2024', text: '建立双重交叉核实机制，成立三人内容复核小组。' },
    { year: '2026', text: '站内累计首发爆料突破 3,860 条，深夜在线读者稳定在 42 万以上。' },
  ],
};

export const footerLinks = [
  {
    title: '热门栏目',
    links: [
      { label: '娱乐瓜田', path: '/category/yule' },
      { label: '商界秘闻', path: '/category/shangjie' },
      { label: '科技内幕', path: '/category/keji' },
      { label: '社会观察', path: '/category/shehui' },
    ],
  },
  {
    title: '更多内容',
    links: [
      { label: '圈内实录', path: '/category/quannei' },
      { label: '深夜电台', path: '/category/diantai' },
      { label: '常见问题', path: '/faq' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '联系与投稿',
    links: [
      { label: '联系我们', path: '/contact' },
      { label: '我要投稿', path: '/contact' },
      { label: '错漏更正', path: '/contact' },
      { label: '商务合作', path: '/contact' },
    ],
  },
];